import { css, styled } from '../../hooks/theme';
import { getCssFont } from '../../styles';
import { Tokens } from '../../types';

export interface BaseLinkProps {
  disabled: boolean;
}

export const BaseLink = styled.a<BaseLinkProps>`
  cursor: pointer;
  & svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  transition: color 0.2s;
  &:link {
    text-decoration: none;
  }
  ${props => {
    const theme = props.theme;
    return css`
      ${getCssFont(theme.font.desktop.paragraph.p2.semibold)}
      color: ${theme.colors.brand.primary[100]};
      &:hover {
        color: ${theme.colors.brand.primary[80]};
      }
      &:active {
        color: ${theme.colors.brand.primary[120]};
        /* outline: 0; */
        /* box-shadow: ${Tokens.boxShadow}; */
      }

      ${props.disabled &&
      css`
        cursor: not-allowed;
        pointer-events: none;
        color: ${theme.colors.neutral.grey[70]};
        &:hover {
          color: ${theme.colors.brand.primary[80]};
        }
        &:active {
          color: ${theme.colors.brand.primary[120]};
        }
      `}
    `;
  }}
`;

BaseLink.defaultProps = {
  theme: Tokens.eixods,
};
